import { render, staticRenderFns } from "./PagesWidget.vue?vue&type=template&id=5e58659c"
import script from "./PagesWidget.vue?vue&type=script&lang=js"
export * from "./PagesWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports